export const email = new RegExp(/\S+@\S+\.\S+/);
export const password = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
